import { getDefaultAvatar } from "@repo/fika-design-system/avatar"
import { createMemo, Show } from "solid-js"
import { createSession } from "@/context/session-provider"
import { navAvatarClass } from "./nav-avatar.css"

interface NavAvatarProps {
  href: string
  title: string
  profileImage?: string | null
}

export function NavAvatar(props: NavAvatarProps) {
  const session = createSession()
  const avatarUrl = createMemo(() => {
    if (props.profileImage) {
      return props.profileImage
    }
    const currentSession = session.session()
    if (currentSession.status === "logged-in") {
      return getDefaultAvatar(currentSession.user.id)
    }
    return null
  })

  return (
    <Show when={avatarUrl()}>
      {url => (
        <a href={props.href} title={props.title} class={navAvatarClass}>
          <img src={url()} alt="Avatar" />
        </a>
      )}
    </Show>
  )
}
